// features/notifications/notificationsSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: null, // The message to show
  type: null, // 'success', 'error', 'info', 'warning'
  open: false, // Whether or not the notification is visible
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      const { message, type } = action.payload;
      state.message = message;
      state.type = type;
      state.open = true;
    },
    hideNotification: (state) => {
      state.open = false;
    },
  },
});

export const { showNotification, hideNotification } =
  notificationsSlice.actions;
export default notificationsSlice.reducer;
